"use client";

import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { useRouter } from "next/navigation";
import React, { useCallback, useMemo } from "react";

import UserInfoMenu from "components/UserInfoMenu";
import useLogout from "hooks/useLogout";

const LogOutOnlyHeader = () => {
  const router = useRouter();

  const onNavItemHover = useCallback(
    (path: string) => {
      router.prefetch(path);
    },
    [router]
  );
  const { logout } = useLogout();

  const menuList = useMemo(
    () => [
      {
        label: "ログアウト",
        onClickMenuItem: () => logout(),
        onHoverMenuItem: () => onNavItemHover("/login"),
        icon: faRightFromBracket,
      },
    ],
    [logout, onNavItemHover]
  );

  return (
    <nav className="flex h-[60px] w-full flex-row justify-between bg-white shadow-card">
      <ul className="flex items-center">
        <li className="flex  h-full border-r px-[16px] py-[11px]">
          <img src="/svg/logo.svg" alt="Home" className="h-[40px] border-normal" />
        </li>
      </ul>
      <UserInfoMenu menuList={menuList} />
    </nav>
  );
};

export default LogOutOnlyHeader;
